import { DataStorage } from '../DataStorage';
export class WarmupDataStorage extends DataStorage {
  constructor(flowAPI) {
    super();
    this.flowAPI = flowAPI;
  }
  get storage() {
    return this.flowAPI.controllerConfig.wixCodeApi.window.warmupData;
  }
  get isSSR() {
    return this.flowAPI.environment.isSSR;
  }
  get(key) {
    return this.isSSR ? null : this.storage.get(key);
  }
  set(key, value) {
    if (!this.isSSR) {
      return;
    }
    return this.storage.set(key, value);
  }
}
//# sourceMappingURL=WarmupDataStorage.js.map